import ReactDOMServer from 'react-dom/server';
import showdown from 'showdown';

const newTagsAttributesMap = {
  a: 'target="_blank"',
};

const newOpeningTagsMap = {
  punch: `span class=punch`,
  lightorange: `span class=lightorange`,
  pink: `span class=pink`,
  green: `span class=green`,
  purple: `span class=green`,
  lightgreen: `span class=lightgreen`,
  small: `span class=small`,
  captiontext: `span class=captiontext`,
};

const newClosingTagsMap = {
  punch: 'span',
  lightorange: 'span',
  pink: 'span',
  green: 'span',
  purple: 'span',
  lightgreen: 'span',
  small: 'span',
  captiontext: 'span',
};

const bindings = Object.keys(newTagsAttributesMap).map(key => ({
  type: 'output',
  regex: new RegExp(`<${key}(.*)>`, 'g'),
  replace: `<${key} ${newTagsAttributesMap[key]} $1>`,
}));

const bindingsOpenTag = Object.keys(newOpeningTagsMap).map(key => ({
  type: 'output',
  regex: new RegExp(`<${key}(.*)>`, 'gi'),
  replace: `<${newOpeningTagsMap[key]} $1>`,
}));

const bindingsClosingTag = Object.keys(newClosingTagsMap).map(key => ({
  type: 'output',
  regex: new RegExp(`</${key}>`, 'gi'),
  replace: `</${newClosingTagsMap[key]}>`,
}));

const converter = new showdown.Converter({
  extensions: [...bindings, ...bindingsOpenTag, ...bindingsClosingTag],
  emoji: true,
});

export const getSingleFile = image => {
  if (!image || !image.data) return null;

  const { url, caption, mime, height, width, ext, alternativeText } =
    image.data.attributes;

  const newFormats = {};

  return {
    url: `${url}` || '',
    caption: caption || '',
    mime: mime || '',
    height: height || '',
    width: width || '',
    srcSet: newFormats || null,
    alt: alternativeText || '',
  };
};

export const getAttributes = data => {
  if (!data.data) return null;

  const item = data.data;

  return {
    id: item.id,
    ...item.attributes,
  };
};

export const getHtml = data => {
  let text = String(data).replace(
    /\/uploads/g,
    `${process.env.IMAGE_URL}/uploads`
  );

  const convertedText = converter.makeHtml(text);

  return convertedText ?? null;
};